
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle } from 'lucide-react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const Success = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="py-16 bg-gray-100">
        <div className="max-w-lg mx-auto px-4">
          <Card>
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="w-8 h-8 text-white" />
              </div>
              
              <h1 className="text-3xl font-bold text-gray-900 mb-4">
                Registration Successful!
              </h1>
              
              <p className="text-gray-700 mb-6">
                Thank you for joining GoldenTicketLucky! You've been successfully entered into our lottery draw. 
                Good luck and may fortune smile upon you!
              </p>
              
              <div className="space-y-4">
                <Button 
                  onClick={() => window.location.href = '/play'}
                  className="w-full bg-yellow-600 hover:bg-yellow-700"
                >
                  Start Playing Now
                </Button>
                
                <Button 
                  onClick={() => window.location.href = '/'}
                  variant="outline"
                  className="w-full"
                >
                  Return to Homepage
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Success;
